import { Routes } from '@angular/router';

import { content } from './shared/routes/routes';
import { Themes } from './components/themes/themes';

export const routes: Routes = [
 
  {
    path: 'maintenance',
    loadComponent: () => import('./maintenance/maintenance').then(m => m.Maintenance),
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout').then(m => m.Layout),
    children: content,
  }
];
